export enum RequestTyeps {
    NEW = "new",
    APPROVED = "approved",
    DECLINED = "rejected",
}
